import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import * as fromProfile from '../store/profile.reducers';
import * as fromDemo from '../../demo/store/demo.reducers';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import {AuthService} from '../../auth/auth.service';
import * as DemoAction from '../../demo/store/demo.actions';

@Component({
    selector: 'app-profile-page-pro',
    templateUrl: './profile-page-pro.component.html',
    styleUrls: ['./profile-page-pro.component.scss'],
    standalone: false
})
export class ProfilePageProComponent implements OnInit, OnDestroy {

  profileState: Observable<fromProfile.State>;
  demoState: Observable<fromDemo.State>;
  profileSubscription: Subscription;
  loadedDemo: boolean = false;

  constructor(
    private store: Store<fromApp.AppState>,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
    this.demoState = this.store.select('demo');
    this.profileSubscription = this.store.select('profile').subscribe(
      (state: fromProfile.State) => {
        if (state.audit !== null) {
          if (state.audit.status === 0 && !this.loadedDemo) {
            const that = this;
            setTimeout(function() {
              that.store.dispatch(
                new DemoAction.GetDemo({id: 'df02de7c-b4ce-11ea-aa70-d45d64400002', saveAsDemo: true})
              );
            }, 3000);

            this.loadedDemo = true;
          }
        }
      }
    );
  }

  isAuthenticated() {
    return this.authService.isAuthenticated();
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
  }

}
